import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

// Layouts
import HomeLayout from "./components/HomeLayout";
import Layouts from "./components/Layouts";

// Pages
import Login from "./pages/login";
import Register from "./pages/register";
import Dashboard from "./pages/dashboard";
import ManageProducts from "./pages/ManageProducts";
import RiskCover from "./RiskCover";
import RiskItem from "./RiskItem";
import GeneralSettings from "./GeneralSettings";
import Home from "./pages/Home";
import AddPolicy from "./pages/layout/addPolicy";
import quotationList from "./pages/quotationList";
import reports from "./pages/reports";
import Customer from "./pages/customer";
import HomeInsuranceList from "./pages/HomeInsuranceList";
import GridLayout from "./pages/layout/gridLayout";
import FormElements from "./pages/form/form-elements";
import FormControls from "./pages/form/form-controls";
import FormComponents from "./pages/form/form-components";
import Affix from "./pages/navigation/affix";
import Dropdown from "./pages/navigation/dropdown";
import Menu from "./pages/navigation/menu";
import Pagination from "./pages/navigation/pagination";
import PageHeader from "./pages/navigation/pageheader";
import Steps from "./pages/navigation/steps";
import Buttons from "./pages/components/buttons";
import Typography from "./pages/components/typography";
import BasicCalendar from "./pages/calendar/basic-calendar";
import NoticeCalendar from "./pages/calendar/notice-calendar";
import SelectableCalendar from "./pages/calendar/selectable-calendar";
import List from "./pages/data-display/list";
import Tooltip from "./pages/data-display/tooltip-popover";
import Carousel from "./pages/data-display/carousel";
import Charts from "./pages/charts";
import Profile from "./pages/profile";
import Table from "./pages/table";
import LanguageSwitcher from "./pages/language-switcher";
import Docs from "./pages/docs";
import policies from "./pages/policies";
import EditQuotation from "./components/grid/EditQuotation";
import editquotation from "./pages/layout/editquotation";
import CancelPolicy from "./pages/cancelPolicy";
import ViewPolicy from "./pages/viewPolicy";
import endorsedPolicy from "./pages/layout/endorsedPolicy";
import AddUnderwriter from "./pages/AddUnderwriter";
import SetPassword from "./pages/SetPassword";
import AddMasterBroker from "./pages/AddMasterBroker";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import RoleList from "./pages/Role_Permissions/RolesList";
import UserDetails from "./pages/UserDetail";
import InsurerList from "./pages/Insurer/Insurer";
import EmailTemplateList from "./pages/Email-Template/EmailTemplateList";
import AssigneTempalte from "./pages/AssigneTemplate/AssignTemplateList";
import AssignedUserList from "./pages/AssigneUser/AssigneUserList";
import ForgotPassword from "./pages/ForgotPassword";
import ManageInsurerRiskCover from "./pages/MasterSettingInsurer/InsurerRiskCover/ManageInsurerRiskCover";
import RiskCoverItem from "./pages/MasterSettingInsurer/InsurerRiskCoverItem/ManageInsurerRiskItem";
import PayPalPayment from "./components/Payment/Index";
import WrappedEditClientQuotation from "./pages/customer/EditClientQuotation";
import Documents from "./components/Documents/Documents";
import AssigneDocumentList from "./components/Documents/AssigneDocument/AssigneDocumentList";
import UploadDocumentList from "./components/Documents/UploadDocuments/UploadDocList";
import PaymentHistory from "./pages/PaymentHistory";
import Communication from "./pages/Communication";
import ClaimLimitList from "./pages/ClaimLimit/ClaimLimitList";
import AdditionalInfoList from "./pages/AdditionalInfo/AdditionalInfoList";
import GlobleDebitNote from "./components/GlobleDebitNote";
import EmailEventList from "./pages/ManageEmailEvent/EventList";
import ManageInsurerProducts from "./pages/MasterSettingInsurer/InsurerProducts/ManageInsurerProducts";
import BulkUpload from "./pages/BulkUpload";
import PremiumSummeryList from "./pages/Premiums/PremiumSummery";
import AuthorisePolicy from "./components/AuthorisePolicy";
import LapsPeriodForm from "./pages/LapsPeriod";
import DiarySystem from "./pages/DiarySystem";
import AssignBroker from "./pages/AssignBroker/AssignBroker";
import AssignUnderwriter from "./pages/AssignUnderwriter/AssigneUnderWriterList";
import AssignMasterBroker from "./pages/AssignMasterBroker/AssignMasterBroker";
import SubscriptionSettings from "./pages/SubscriptionSettings";
import CustomerStatement from "./pages/CustomerStatement";
import EsclateSystem from "./pages/EscalateIssues";
import GenerateQuote from "./pages/GenerateQuote";
import AssignClaimManagerList from "./pages/AssignClaimManager/AssigneClaimManagerList";
import AddEditFieldTypeForm from "./pages/ClaimForms/AddEditFieldTypes";
import FieldTypeForm from "./pages/ClaimForms/FieldTypes";
import AddEditClaimFormField from "./pages/ClaimForms/AddEditClaimFormField";
import ClaimFormFields from "./pages/ClaimForms/ClaimFormFields";
import ClaimFormPage from './pages/ClaimForms/Form';
import EscalateCustomerReply from "./pages/EscalateCustomerReply";
import PolicyTable from "./pages/FinancePolices";
import SubscribePage from "./pages/Subscribe/SubscribePage";
import SubscribeSuccess from "./pages/Subscribe/SubscribeSuccess";
import Users from "./pages/Users";
import Endorsement from "./pages/Endorsement/Endorsement";
import EndorsementType from "./pages/Endorsement/EndorsementType";
import ReinsuranceReport from "./pages/ReinsuranceReport";
import ReinsurerAmountDueReport from "./pages/ReinsurerAmountDueReport";
import BrokerPoliciesReport from "./pages/BrokerPoliciesReport";
import ClaimPendingReport from "./pages/ClaimPendingReport";
import ClaimSettledReport from "./pages/ClaimSettledReport";
import ClaimRejectedReport from "./pages/ClaimRejecteddReport";
import CurrencyConversion from "./pages/CurrencyConversion";
import DownloadPolicyDocuments from "./pages/DownloadPolicyDocuments";
import ManageDocuments from "./pages/ManageDocuments";
import ManageDocumentMapping from "./pages/ManageDocumentMapping";
import StampDuty from "./pages/StampDuty";
import ClaimFormReport from "./pages/ClaimFormReport";
import EditCrmPolicy from "./pages/Crm/EditCrmPolicy";

const PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  return (
    <Route
      {...rest}
      render={(props) => {
        console.log("Matched route:", rest.path);
        if (isAuthenticated) {
          return Layout ? (
            <Layout>
              <Component {...props} />
            </Layout>
          ) : (
            <Component {...props} />
          );
        } else {
          return <Redirect to="/" />;
        }
      }}
    />
  );
};



const Routes = () => {
  const location = useLocation();
  return (
    <Switch>
      {/* Public Routes */}
      <Route exact path="/" component={Login} />
      <Route exact path="/set-password" component={SetPassword} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route exact path="/client/edit-quotation" component={WrappedEditClientQuotation} />
      {/* <Route exact path="/home/email-template" component={EmailTemplateList}/>
      <Route exact path="/home/assigne-templates" component={AssigneTempalte}/> */}
      <Route
        path="/home"
        render={(props) => {
          const token = localStorage.getItem("token");

          return token ? (
            // <HomeLayout>
            <Switch>
              <PrivateRoute exact path="/home" component={Home} layout={HomeLayout} />
              <PrivateRoute exact path="/home/register" component={Register} layout={HomeLayout} />
              <PrivateRoute exact path="/home/users" component={Users} layout={HomeLayout} />
              <PrivateRoute exact path="/home/manageProducts" component={ManageProducts} layout={HomeLayout} />
              <PrivateRoute exact path="/home/riskCover" component={RiskCover} layout={HomeLayout} />
              <PrivateRoute exact path="/home/riskItem" component={RiskItem} layout={HomeLayout} />
              <PrivateRoute exact path="/home/generalSettings" component={GeneralSettings} layout={HomeLayout} />
              <PrivateRoute exact path="/home/role-permissions" component={RoleList} layout={HomeLayout} />
              <PrivateRoute exact path="/home/user-detail" component={UserDetails} layout={HomeLayout} />
              <PrivateRoute exact path="/home/insurerList" component={InsurerList} layout={HomeLayout} />
              <PrivateRoute exact path="/home/email-template" component={EmailTemplateList} layout={HomeLayout} />
              <PrivateRoute exact path="/home/assigne-templates" component={AssigneTempalte} layout={HomeLayout} />
              <PrivateRoute exact path="/home/assigne-users" component={AssignedUserList} layout={HomeLayout} />
              <PrivateRoute path="/home/document-upload" component={UploadDocumentList} layout={HomeLayout} />
              <PrivateRoute path="/home/assigne-document" component={AssigneDocumentList} layout={HomeLayout} />
              <PrivateRoute path="/home/claim-thresholds" component={ClaimLimitList} layout={HomeLayout} />
              <PrivateRoute path="/home/additional-info" component={AdditionalInfoList} layout={HomeLayout} />
              <PrivateRoute path="/home/email-events" component={EmailEventList} layout={HomeLayout} />
              <PrivateRoute path="/home/bulk-upload-data" component={BulkUpload} layout={HomeLayout} />
              <PrivateRoute path="/home/premium-summery" component={PremiumSummeryList} layout={HomeLayout} />
              <PrivateRoute path="/home/diary-system" component={DiarySystem} layout={HomeLayout} />
              <PrivateRoute exact path="/home/assign-broker" component={AssignBroker} layout={HomeLayout} />
              <PrivateRoute exact path="/home/assign-underwriter" component={AssignUnderwriter} layout={HomeLayout} />
              <PrivateRoute exact path="/home/assign-masterbroker" component={AssignMasterBroker} layout={HomeLayout} />
              <PrivateRoute exact path="/home/escalate-issues" component={EsclateSystem} layout={HomeLayout} />
              <PrivateRoute exact path="/home/assigne-claim-manager" component={AssignClaimManagerList} layout={HomeLayout} />
              <PrivateRoute exact path="/home/claim/manage-fields" component={FieldTypeForm} layout={HomeLayout} />
              <PrivateRoute exact path="/home/claim/edit-field" component={AddEditFieldTypeForm} layout={HomeLayout} />
              <PrivateRoute exact path="/home/claim/add-field" component={AddEditFieldTypeForm} layout={HomeLayout} />
              <PrivateRoute exact path="/home/claim/manage-claim-field/:claimFormId" component={ClaimFormFields} layout={HomeLayout} />
              <PrivateRoute exact path="/home/claim/add-claim-field" component={AddEditClaimFormField} layout={HomeLayout} />
              <PrivateRoute exact path="/home/claim/edit-claim-field" component={AddEditClaimFormField} layout={HomeLayout} />
              <PrivateRoute exact path="/home/claim/forms" component={ClaimFormPage} layout={HomeLayout} />
              <PrivateRoute exact path="/home/policy" component={PolicyTable} layout={HomeLayout} />
              <PrivateRoute exact path="/home/endorsement" component={Endorsement} layout={React.Fragment} />
              <PrivateRoute exact path="/home/ManageDocuments" component={ManageDocuments} layout={HomeLayout}/>
              <PrivateRoute exact path="/home/ManageDocumentMapping" component={ManageDocumentMapping} layout={HomeLayout}/>
               <PrivateRoute exact path="/home/Crm/EditCrmPolicy/:policyId?" component={EditCrmPolicy} layout={HomeLayout}/>
             
              {/* Catch-all fallback inside /home */}
              <Route path="*">
                <div style={{ padding: "2rem" }}>404 - Page Not Found</div>
              </Route>
            </Switch>
            // </HomeLayout>
          ) : (
            <Redirect to="/" />
          );
        }}
      />

      <Route path="/" render={(props) => (
        // <Layouts>
        <Switch>
          <PrivateRoute exact path="/dashboard" component={Dashboard} layout={React.Fragment} />
          <PrivateRoute exact path="/addUnderwriter" component={AddUnderwriter} layout={React.Fragment} />
          <PrivateRoute exact path="/addMasterBroker" component={AddMasterBroker} layout={React.Fragment} />
          <PrivateRoute exact path="/CreateQuotation" component={AddPolicy} layout={React.Fragment} />
          <PrivateRoute exact path="/layout/editquotation/:quotationId" component={editquotation} layout={React.Fragment} />
          <PrivateRoute exact path="/customers" component={Customer} layout={React.Fragment} />
          <PrivateRoute exact path="/quotations/:quotationNumber?" component={quotationList} layout={React.Fragment} />
          <PrivateRoute exact path="/reports" component={reports} layout={React.Fragment} />
          <PrivateRoute exact path="/policies/:policyNumber?" component={policies} layout={React.Fragment} />
          <PrivateRoute exact path="/HomeInsuranceList" component={HomeInsuranceList} layout={React.Fragment} />
          <PrivateRoute exact path="/layout/gridLayout" component={GridLayout} layout={React.Fragment} />
          <PrivateRoute exact path="/form/form-elements" component={FormElements} layout={React.Fragment} />
          <PrivateRoute exact path="/form/form-controls" component={FormControls} layout={React.Fragment} />
          <PrivateRoute exact path="/form/form-components" component={FormComponents} layout={React.Fragment} />
          <PrivateRoute exact path="/navigation/affix" component={Affix} layout={React.Fragment} />
          <PrivateRoute exact path="/navigation/dropdown" component={Dropdown} layout={React.Fragment} />
          <PrivateRoute exact path="/navigation/menu" component={Menu} layout={React.Fragment} />
          <PrivateRoute exact path="/navigation/pagination" component={Pagination} layout={React.Fragment} />
          <PrivateRoute exact path="/navigation/pageheader" component={PageHeader} layout={React.Fragment} />
          <PrivateRoute exact path="/navigation/steps" component={Steps} layout={React.Fragment} />
          <PrivateRoute exact path="/components/buttons" component={Buttons} layout={React.Fragment} />
          <PrivateRoute exact path="/components/typography" component={Typography} layout={React.Fragment} />
          <PrivateRoute exact path="/calendar/basic-calendar" component={BasicCalendar} layout={React.Fragment} />
          <PrivateRoute exact path="/EditQuotation" component={EditQuotation} layout={React.Fragment} />
          <PrivateRoute exact path="/cancelPolicy" component={CancelPolicy} layout={React.Fragment} />
          <PrivateRoute exact path="/viewPolicy" component={ViewPolicy} layout={React.Fragment} />
          <PrivateRoute exact path="/endorsedPolicy/:policyId?" component={endorsedPolicy} layout={React.Fragment} />
          <PrivateRoute exact path="/calendar/notice-calendar" component={NoticeCalendar} layout={React.Fragment} />
          <PrivateRoute exact path="/calendar/selectable-calendar" component={SelectableCalendar} layout={React.Fragment} />
          <PrivateRoute exact path="/data-display/list" component={List} layout={React.Fragment} />
          <PrivateRoute exact path="/data-display/tooltip-popover" component={Tooltip} layout={React.Fragment} />
          <PrivateRoute exact path="/data-display/carousel" component={Carousel} layout={React.Fragment} />
          <PrivateRoute exact path="/charts" component={Charts} layout={React.Fragment} />
          <PrivateRoute exact path="/profile" component={Profile} layout={React.Fragment} />
          <PrivateRoute exact path="/table" component={Table} layout={React.Fragment} />
          <PrivateRoute exact path="/language-switcher" component={LanguageSwitcher} layout={React.Fragment} />
          <PrivateRoute exact path="/docs" component={Docs} layout={React.Fragment} />
          <PrivateRoute exact path="/insurer-risk-cover" component={ManageInsurerRiskCover} layout={React.Fragment} />
          <PrivateRoute exact path="/insurer-risk-cover-item" component={RiskCoverItem} layout={React.Fragment} />
          <PrivateRoute exact path="/insurer-products" component={ManageInsurerProducts} layout={React.Fragment} />
          <PrivateRoute path="/payment/:policyId" component={PayPalPayment} layout={React.Fragment} />
          <PrivateRoute exact path="/policies/documents/:policyId/:policynumber/:insurerId" component={Documents} layout={React.Fragment} />
          <PrivateRoute path="/payment-history" component={PaymentHistory} layout={React.Fragment} />
          <PrivateRoute path="/subsciption-settings" component={SubscriptionSettings} layout={React.Fragment} />
          <PrivateRoute path="/customer-statement" component={CustomerStatement} layout={React.Fragment} />
          <PrivateRoute path="/communication" component={Communication} layout={React.Fragment} />
          <PrivateRoute path="/debit-note" component={GlobleDebitNote} layout={React.Fragment} />
          <PrivateRoute path="/authorise-policy/:policyId" component={AuthorisePolicy} layout={React.Fragment} />
          <PrivateRoute path="/generate-quote" component={GenerateQuote} layout={React.Fragment} />
          <PrivateRoute exact path="/escalate-issues-customer" component={EscalateCustomerReply} layout={React.Fragment} />
          <PrivateRoute exact path="/subscribe/:policyId" component={SubscribePage} layout={React.Fragment} />
          <PrivateRoute exact path="/subscribe-success" component={SubscribeSuccess} layout={React.Fragment} />
          <PrivateRoute exact path="/endorsement-type" component={EndorsementType} layout={React.Fragment} />
          <PrivateRoute exact path="/laps-setting" component={LapsPeriodForm} layout={React.Fragment} />
          <PrivateRoute path="/ReinsuranceReport" component={ReinsuranceReport} layout={React.Fragment} />
          <PrivateRoute path="/ReinsurerAmountDueReport" component={ReinsurerAmountDueReport} layout={React.Fragment} />
          <PrivateRoute path="/BrokerPoliciesReport" component={BrokerPoliciesReport} layout={React.Fragment} />
          <PrivateRoute path="/ClaimPendingReport" component={ClaimPendingReport} layout={React.Fragment} />
          <PrivateRoute path="/ClaimSettledReport" component={ClaimSettledReport} layout={React.Fragment} />
          <PrivateRoute path="/ClaimRejectedReport" component={ClaimRejectedReport} layout={React.Fragment} />
          <PrivateRoute path="/DownloadPolicyDocuments/:id" component={DownloadPolicyDocuments} layout={React.Fragment} />
           <PrivateRoute exact path="/currency-rate" component={CurrencyConversion} layout={React.Fragment} />
           <PrivateRoute exact path="/stamp-duty" component={StampDuty} layout={React.Fragment} />
           <PrivateRoute exact path="/ClaimFormReport" component={ClaimFormReport} layout={React.Fragment} />
        </Switch>
        // </Layouts>
      )}
      />

      {/* Catch-all for unknown routes */}
      <Route render={() => <Redirect to="/dashboard" />} />
    </Switch>
  );
};

export default Routes;
